import { Grid } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import Container from '../../../constants/Container'
import ProfileHeaderView from '../../../components/front_office/cu_profile/ProfileHeaderView'
import ProfileListView from '../../../components/front_office/cu_profile/ProfileListView'
import AppURL from '../../../constants/AppURL'
import useFetchData from '../../../helpers/useFetch'
import SecHeading from '../../../constants/SecHeading'

const ConsumerProfileCreateListView = () => {
    const [onSearch, setOnSearch] = useState("")

    const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/customer/profile/lock/unlock/all/list/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    return (
        <Fragment>
            <Grid container>

                {/* <Grid item lg={12} xl={12} md={12} xs={12}>
                    <Container padding>
                        <ProfileHeaderView onSearch={onSearch} refetch={refetch} setOnSearch={setOnSearch} />
                    </Container>
                </Grid> */}
                <Grid item lg={12} xl={12} md={12} xs={12}>
                    <Container padding>
                        <SecHeading type='list' label='Consumer List' />

                        <ProfileListView data={data} refetch={refetch} loading={loading} setOnURL={setOnURL} />
                    </Container>
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default ConsumerProfileCreateListView